module.exports = __webpack_public_path__ + "static/media/SF_bm_primaerlogo_innlandet_neg.7612e3d9.pdf";